import { yup } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

export const emailValidationSchema = (t) => yup.object({
    email: yup
        .string()
        .email(t(I18N_NAMESPACE, "forms.loginForm.fields.email.validityMessage"))
        .required(t(I18N_NAMESPACE, "forms.loginForm.fields.email.requireMessage")),
})